import { createStore } from 'vuex'

export default createStore({
    state: {
        token: '',
        currentState: '',
        totalPoint: 0,
        openId: '',
        orderDetails: {},
        exchangeDetails: {}
    },
    mutations: {
        setToken(state, token) {
            state.token = token
        },

        setCurrentState(state, currentState) {
            state.currentState = currentState;
        },

        setTotalPoint(state, totalPoint) {
            state.totalPoint = totalPoint;
        },

        setOpenId(state, openId) {
            state.openId = openId;
        },

        setOrderDetails(state, orderDetails) {
            state.orderDetails = orderDetails;
        },

        setExchangeDetails(state, exchangeDetails) {
            state.exchangeDetails = exchangeDetails;
        }
    },
    actions: {
        setToken(context, token: any) {
            context.commit('setToken', token)
        },

        setCurrentState(context, currentState: any) {
            context.commit('setCurrentState', currentState)
        },

        setTotalPoint(context, totalPoint: number) {
            context.commit('setTotalPoint', totalPoint)
        },

        setOpenId(context, openId: any) {
            context.commit('setOpenId', openId)
        },

        setOrderDetails(context, orderDetails: any) {
            context.commit('setOrderDetails', orderDetails)
        },

        setExchangeDetails(context, exchangeDetails: any) {
            context.commit('setExchangeDetails', exchangeDetails)
        },
    },
    modules: {

    },
    getters: {
        more5stu (state) { return state.token }
    }
})